import React from 'react';

interface ReasultSearchBarProps{
  setSearch : (search : string ) => void;
  search : string

}


export const ReasultSearchBar :React.FC<ReasultSearchBarProps> = ({setSearch, search}) =>{

  return(
    <div>
      <form>
        <label >
          결과 내 검색 : {' '}
          <input 
            type='text'
            value={search}
            onChange={e=>setSearch(e.target.value)}
            placeholder='책 제목을 입력하세요.'
          /> 
        </label>
      </form>
    </div>
  )
}